import script from "./AttractionList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttractionList.vue?vue&type=script&setup=true&lang=js"

import "./AttractionList.vue?vue&type=style&index=0&id=6fb29802&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb29802"]])

export default __exports__